import React from 'react';
import { getFacilityName, sponsors } from '../data/sponsors';

const Sponsors: React.FC = () => {
  const diamondSponsors = sponsors.filter((sponsor) => sponsor.tier === 'diamond');

  return (
    <div className="page-container">
      <div className="sponsors-page">
        <div className="sponsors-container">
          <h1 className="page-title">Our Corporate Sponsors</h1>
          <p className="page-subtitle">Diamond Sponsors</p>
          <div className="sponsors-grid">
            {diamondSponsors.map((sponsor) => (
              <div key={sponsor.id} className="sponsor-card sponsor-card-diamond">
                <div className="sponsor-card-header">
                  {sponsor.logo ? (
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className={`sponsor-logo${sponsor.logoClass ? ` ${sponsor.logoClass}` : ''}`}
                    />
                  ) : (
                    <div className="sponsor-placeholder">
                      <span>{sponsor.name}</span>
                    </div>
                  )}
                </div>
                <h3 className="sponsor-name">{sponsor.name}</h3>
                {sponsor.sponsoredFacilities && sponsor.sponsoredFacilities.length > 0 && (
                  <div className="sponsor-facility-badges">
                    {sponsor.sponsoredFacilities.map((facility) => (
                      <span key={facility} className="sponsor-facility-badge">
                        {getFacilityName(facility)} Sponsor
                      </span>
                    ))}
                  </div>
                )}
                {sponsor.website && (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sponsor-link"
                  >
                    Visit Website →
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sponsors;


